import { IAction } from 'typed/actions/utils';
import { IReducer } from './';

type ReducersMapObject<S = any, A extends IAction<string, any> = IAction<string, any>> = { [K in keyof S]: IReducer<S[K], A> }
type InferActionTypes<R> = R extends IReducer<any, infer A> ? A : never;
type InferReducerTypes<T> = T extends Record<any, infer R> ? R : never;
type InferStateType<T> = T extends ReducersMapObject<infer S, any> ? S : never;
type InferActionType<T> = InferActionTypes<InferReducerTypes<T>>;

export default function combineReducers<T extends ReducersMapObject<any, any>, S extends InferStateType<T>>(def: S, reducersStructure: T): IReducer<S, InferActionType<T>>;
export default function combineReducers<T extends ReducersMapObject<any, any>>(reducersStructure: T): IReducer<InferStateType<T>, InferActionType<T>>;
export default function combineReducers<T extends ReducersMapObject<any, any>, S extends InferStateType<T>>(...args: any): IReducer<InferStateType<T>, InferActionType<T>> {
    const [def, reducersStructure]: [S | undefined, T] = args.length === 2 ? args : [undefined, ...args];

    const keys: { key: string, reducer: any }[] = [] as any;
    for (let key in reducersStructure) {
        keys.unshift({ key: key, reducer: reducersStructure[key] });
    }

    return function combinedReducers(state: any = (def || {}) as any, action: any) {
        const
            isArray = Array.isArray(state),
            newState = Object.assign(isArray ? [] : {}, state);
        let changed = false,
            i = keys.length; // https://jsperf.com/fastest-array-loops-in-javascript/32
        while (i--) {
            const
                { key, reducer } = keys[i],
                newStatePart = reducer(state[key], action);
            if (state[key] !== newStatePart) {
                newState[key] = newStatePart;
                changed = true;
            }
        }
        return changed ? newState : state;
    };
}